import React, { createContext, useState } from "react";

const AppContext = createContext(null);
const { Provider } = AppContext;

const AppProvider = ({ children }) => {
  const [selectedAPIKey, setSelectedAPIKey] = useState(null);
  // const [selectedAPIKey, setSelectedAPIKey] = useState(
  //   "71944e94-ef5c-4215-b2f9-789dca622c5b.2551d4ed-a61d-4b4b-a666-a9f4b018a126"
  // );
  const [accountId, setAccountId] = useState("");
  const [validationStatus, setValidationStatus] = useState(null);
  const [sessionEnded, setSessionEnded] = useState(false);
  const [showWebPage, setShowWebPage] = useState(false);

  return (
    <Provider
      value={{
        selectedAPIKey,
        setSelectedAPIKey,
        accountId,
        setAccountId,
        validationStatus,
        setValidationStatus,
        sessionEnded,
        setSessionEnded,
        showWebPage,
        setShowWebPage,
      }}
    >
      {children}
    </Provider>
  );
};

export { AppContext, AppProvider };
